/* Reveal on scroll.
   Elements lift and fade in as they enter the viewport.

   The hidden state is applied BY THIS SCRIPT, never in the stylesheet. If the script
   fails or is blocked, everything stays visible rather than a blank page. Anything
   already on screen at load is revealed immediately with no animation, so the top of
   the page never appears to flicker. */
(function () {
  if (!('IntersectionObserver' in window)) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var GROUPS = [
    '.sc-card',                       // trending product cards
    '.sc-cat',                        // range tiles
    '.sc-trust .sc-wrap span',        // trust strip claims
    '.sc-story .sc-stat',             // story stats
    '.product-grid__item'             // catalog cards
  ];
  var SINGLES = [
    '.sc-headline-row',
    '.sc-cats h2',
    '.sc-story h2',
    '.sc-story .sc-body',
    '.sc-story .sc-plate',
    '.sc-capture h2',
    '.sc-capture p',
    '.sc-capture .sc-form',
    '.sc-eyebrow'
  ];

  function prepare(el, delay) {
    if (el.dataset.pfReveal) return;
    el.dataset.pfReveal = '1';
    el.classList.add('pf-reveal');
    if (delay) el.style.transitionDelay = delay + 'ms';
  }

  // On desktop the scrolling element is .page-wrapper, so the observer must use it as
  // its root or nothing ever counts as "entering the viewport".
  var pw = document.querySelector('.page-wrapper');
  var ioRoot = null;
  if (pw) {
    var oy = getComputedStyle(pw).overflowY;
    if (oy === 'auto' || oy === 'scroll') ioRoot = pw;
  }

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('pf-revealed');
      io.unobserve(entry.target);
    });
  }, { root: ioRoot, rootMargin: '0px 0px -12% 0px', threshold: 0.08 });

  function collect() {
    GROUPS.forEach(function (sel) {
      var parents = {};
      document.querySelectorAll(sel).forEach(function (el) {
        var key = el.parentElement;
        parents.i = parents.i || 0;
        if (!key.dataset.pfIndex) key.dataset.pfIndex = '0';
        var i = parseInt(key.dataset.pfIndex, 10);
        key.dataset.pfIndex = String(i + 1);
        prepare(el, Math.min(i, 5) * 70);   // stagger, capped so later items are not slow
      });
    });
    SINGLES.forEach(function (sel) {
      document.querySelectorAll(sel).forEach(function (el) { prepare(el, 0); });
    });

    document.querySelectorAll('.pf-reveal').forEach(function (el) {
      var r = el.getBoundingClientRect();
      // already on screen at load: show it straight away, no animation
      if (r.top < window.innerHeight && r.bottom > 0) {
        el.style.transitionDelay = '0ms';
        el.classList.add('pf-revealed', 'pf-instant');
      } else {
        io.observe(el);
      }
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', collect);
  else collect();
})();
